// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Regras')),
  route('create', '/create', Form, professionalMeta('Adicionar Regra')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar Regra'))
]

export default subGroup('/rules', routes)



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/routes.js